import React, { useContext, useEffect, useRef, useState } from 'react'
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useDispatch, useSelector } from "react-redux";
import { cloneDeep } from 'lodash';
import { genKey, getUniqueWorkflowItemIdFromArray, findParentLoopNodes, getSelectedNodeWhileCreation } from '../../../utils/utilFunctions';
import { treeActions } from '../../../redux/slices/treeSlice';
import { getRecordInsertingPosition } from './CopyAndPaste';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { getUpdatedData } from './NewGetData';

function NewLoop({ openModal,toggle }) {
  const {t} = useTranslation()
  const parentScreen = useContext(ParentScreenCtx) 
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const { templateHeader } = useSelector(state => state.treeData.workflow.rightTree.tree)
  const currentTab = rightTree.currentTab;
  const selectedNode = rightTree.tree[currentTab].selectedNode;
  const dispatch = useDispatch();
  const [showModal,setShowModal] = useState(false)
  const contentRef = useRef();
  const content = t('BOX_LIKE_TO_PLACE_ELEM_INSIDE_CURR_ELEM_OR_DIRECTLY_AFTER').split(`\\n`).join("<br />")
  
  const handleNewLoop = (isInside) => {
    const exactNode = getSelectedNodeWhileCreation(selectedNode, rightTree?.tree?.[currentTab]?.translatedData || [], isInside);
    let nestedLevels = exactNode.key.split("-");
    nestedLevels = nestedLevels.splice(1);
    const translatedData = cloneDeep(rightTree.tree[currentTab].translatedData);
    let initialId = translatedData?.[0]?.ID;
    const newId = getUniqueWorkflowItemIdFromArray(translatedData);

    const getNewGetData = (data,key,isInside) => {
       const title = "Loop"
       if (!data.length) {
         return { key: `${key}-0`, title, placingPosition:1 };
       }

       let placingPosition;
       let newGetDataKey;
       
       const details = getRecordInsertingPosition(
         data,
         exactNode,
         isInside,
         "workflow"
       );
       placingPosition = details.index;
       newGetDataKey = details.key;
       return { key: newGetDataKey, title, placingPosition: placingPosition };
    }
    
    const insertNodeInNestedTree = (translatedData,nestedLevels,isInside) => {
        const level = isInside ? 0: 1;
        if(nestedLevels.length === level){
            const {children = [], key} = translatedData;
            const newGetDataDetails = children ? getNewGetData(children,key,isInside) : getNewGetData(translatedData, 'wf', isInside);
            
            // Check for parent loops to inherit LOG_WFITEM_DETAILS setting
            const parentLoops = findParentLoopNodes(translatedData, selectedNode.key);
            const hasParentWithDoNotLog = parentLoops.some(loop => loop.LOG_WFITEM_DETAILS === "FALSE");
            
            const newNode = {
                key: newGetDataDetails.key,
                title: newGetDataDetails.title,
                nodeId: genKey(newGetDataDetails.title),
                alternateNodeId: genKey(newGetDataDetails.title),
                ICON_DISPLAY: 'LOOP_ITEM',
                ACTION:"LOOP_ITEM",
                CONCURRENT:"FALSE" ,
                ENABLED:"TRUE" ,
                ID:newId,
                LOG_WFITEM_DETAILS: hasParentWithDoNotLog ? "FALSE" : "TRUE",
                LOOP_DELIM:"" ,
                LOOP_OVER_LIST:"" ,
                LOOP_OVER_VALUE:"" ,
                LOOP_TYPE:"" ,
                MAX_LOOPS:"999" ,
                MAX_THREADS:"5" ,
                NAME:"Loop",
                children: [],
            }
            dispatch(
              treeActions.setRightTreeSelectedNode({
                screen: parentScreen,
                type: currentTab,
                data: {},
              })
            );
           const translatedDataArray= children ? translatedData.children : translatedData;
            translatedDataArray.splice(newGetDataDetails.placingPosition,0,newNode);
            setTimeout(() => {
                dispatch(treeActions.setRightTreeSelectedNode({
                    screen: parentScreen,
                    type:currentTab, 
                    data:{...newNode}
                    }));
            })
            return; 
        }
        const isArray = Array.isArray(translatedData);

        if (isArray) {
            const nestedData = translatedData[[nestedLevels[0]]];
            const newNestedLevels = nestedLevels.splice(1);
            insertNodeInNestedTree(nestedData, newNestedLevels, isInside);
        } else {
            insertNodeInNestedTree(translatedData?.children, nestedLevels, isInside);
        }
    }

    insertNodeInNestedTree(translatedData, nestedLevels, isInside);
    const updatedData = getUpdatedData(translatedData,initialId);
    dispatch(treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: currentTab,
        data: updatedData
    }));
    toggle(prev => null);
    setShowModal(false);
  }
  
  const newLoopHandler = () => {
    if(['LOOP_ITEM','CONDITION_IF','CONDITION_ELSE'].includes(selectedNode.ICON_DISPLAY) && openModal){
      setShowModal(true);
    } else if(selectedNode.key === 'wf-0' && selectedNode.ICON_DISPLAY === 'OBJECTS') {
        handleNewLoop(true);
        return;
    } else {
        handleNewLoop(false);
      return;
    }
  }  
  setTimeout(() => {
    if (contentRef.current?.innerHTML === "") contentRef.current.innerHTML = content
  }, 0)
  
  useEffect(() => {
    if (openModal) newLoopHandler();
  }, [openModal]);
    
  return (
    <>
     <Dialog open={showModal} maxWidth="xs" fullWidth>
       <DialogTitle className='dialog-header'>
        <div className='title'>{t('BOX_CONFIRM')}</div>
       </DialogTitle>
       <DialogContent className='dialog-content' dividers>
         <div ref={contentRef}></div>
       </DialogContent>
       <DialogActions>
         <Button size='small' variant='outlined' color="primary" onClick={() => handleNewLoop(true)}>
          {t('BTN_YES')}
         </Button>
         <Button size='small' variant='outlined' color="primary" onClick={() => handleNewLoop(false)}>
          {t('BTN_NO')}
         </Button>
         <Button size='small' variant='outlined' color="primary" onClick={() => {
          toggle(null);
          setShowModal(false)
         }}>
          {t('BTN_CANCEL')}
         </Button>
       </DialogActions>
     </Dialog>
    </>
  )
}

export default NewLoop



